import React from 'react';

const UserCashFormModal = React.lazy(() => import('../components/FormModal'));
const userCashModalRegistry = {
    core_userCashId: UserCashFormModal
};
export default userCashModalRegistry;
